// extracted by mini-css-extract-plugin
export default {"customSessionTimeoutContent":"custom-session-timeout-container__custom-session-timeout-content__NPl3y"};